import { jsx } from "react/jsx-runtime";
import { cx, css } from "@/styled-system/css";
import React from "react";
const videoClass = css({
  display: "block"
});
const Video = React.forwardRef(({
  className,
  ...props
}, ref) => /* @__PURE__ */ jsx("video", { ref, className: cx(videoClass, className), ...props }));
Video.displayName = "Video";
export {
  Video as default
};
